import { SpineGameObject } from "@esotericsoftware/spine-phaser";
import Phaser from "phaser";
import Reel from "./Reel";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";

export default class Cell {
    public scene: any; // Generico per evitare dipendenze circolari
    public gameLogicVariableManager: any;
    public reel: Reel | null;

    private container: Phaser.GameObjects.Container;
    private linkSpinContainer: Phaser.GameObjects.Container;

    private delayedAnimForMemo?: Phaser.Time.TimerEvent;
    private linkSpineValueText: Phaser.GameObjects.Text;

    private on: boolean = true;
    private memo: number = 0;
    private index: number;
    private reelIndex: number;

    static OnOffAnimationTrack: number = 0;
    static WinAnimationTrack: number = 0;
    static OnOffAnimationAlpha: number = 1;
    static WinAnimationAlpha: number = 1;

    private baseSymbolImageRaw: any; //simboli statici raw
    private baseSymbolSpineRaw: any; //simboli spines raw

    private baseSymbolImage: Phaser.GameObjects.Image;
    private baseSymbolSpines: SpineGameObject[];
    private layoutBuilder: any;

    public constructor(scene: any, _x: number, _y: number, index: number, reelIndex: number) {
        this.scene = scene;
        this.gameLogicVariableManager = (window as any).GameLogicVariableManager;
        this.reel = null;
        this.layoutBuilder = (window as any).LayoutBuilder;

        this.index = index;
        this.reelIndex = reelIndex;

        let cellGeom = this.layoutBuilder.getNodeByPath(`Basegame/grid/reel_${reelIndex}/cell_${index}/cell#geom`);
        
        this.baseSymbolSpineRaw = ResourcesDispatcher.GAME_CONSTANTS.symbolSpines;
        this.baseSymbolImageRaw = ResourcesDispatcher.GAME_CONSTANTS.symbolImagesOn;

        this.baseSymbolImage = this.scene.add.image(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.getSymbolImageRaw(0).key, this.getSymbolImageRaw(0).frame)
        .setOrigin(cellGeom?.phaser.display?.originX, cellGeom?.phaser.display?.originY);

        this.baseSymbolSpines = [];
        for (let i = 0; i < this.baseSymbolSpineRaw.length; i++) {
            const spine = this.scene.add.spine(cellGeom?.phaser.display?.x, cellGeom?.phaser.display?.y, this.getSymbolSpineRaw(i).jsonKey, this.getSymbolSpineRaw(i).atlasKey).setOrigin(0.5).setVisible(false);
            this.baseSymbolSpines.push(spine);
        }

        let linkFont = this.scene.globalVariableManager.getFont().overrideFont({fontSize: 50, color: "#FF0000"});
        this.linkSpineValueText = this.scene.add.text(0, 0, "", linkFont).setOrigin(0.5);

        this.linkSpinContainer = this.scene.add.container(0, 0, [this.linkSpineValueText]).setVisible(false);
        this.container = this.layoutBuilder.findByPath(`Basegame/grid/reel_${reelIndex}/cell_${index}`) as Phaser.GameObjects.Container;

        this.container.add([this.baseSymbolImage, ...this.baseSymbolSpines, this.linkSpinContainer]);

    }

    public setOn(on: boolean) {
        this.on = on;
    }

    public setMemo(memo: number) {
        this.memo = memo;
    }

    public setIndex(index: number) {
        this.index = index;
    }

    /** PUBLIC GETTERS **/
    public getOn(): boolean {
        return this.on;
    }

    public getMemo(): number {
        return this.memo;
    }

    public getContainer(): Phaser.GameObjects.Container {
        return this.container;
    }
    
    public getBaseContainer(): Phaser.GameObjects.Container {
        // return this.baseGameContainer;
        return null as any;
    }
    
    public getLinkSpinContainer(): Phaser.GameObjects.Container {
        return this.linkSpinContainer;
    }

    public getIndex(): number {
        return this.index;
    }

    public getSymbolSpines(): any {
        return this.baseSymbolSpineRaw;
    }

    public getSymbolSpineRaw(memo: number): any {
        return this.baseSymbolSpineRaw[memo];
    }

    public getSpine(memo: number): SpineGameObject {
        return this.baseSymbolSpines[memo];
    }

    public getImage(): Phaser.GameObjects.Image {
        return this.baseSymbolImage;
    }

    public setReel(reel: Reel): void {
        this.reel = reel;
    }

    public refreshInternalPositions(): void {

        const cellGeom = this.layoutBuilder.getNodeByPath(`Basegame/grid/reel_${this.reelIndex}/cell_${this.index}/cell#geom`);
        if (!cellGeom) return;
        const x = cellGeom.phaser?.display?.x ?? 0;
        const y = cellGeom.phaser?.display?.y ?? 0;
        this.baseSymbolImage.setPosition(x, y);
        this.baseSymbolImage.setOrigin(cellGeom.phaser?.display?.originX ?? 0.5, cellGeom.phaser?.display?.originY ?? 0.5);
        this.baseSymbolSpines.forEach(spine => spine.setPosition(x, y));
    }
    /*******************/


    /** PRIVATE GETTERS **/
    private getExtraWildSpine(): SpineGameObject {
        return this.baseSymbolSpines[ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD];
    }

    private getSymbolImageRaw(memo: number): any {
        return this.baseSymbolImageRaw[memo];
    }
    /*******************/

    private applySymbolTint(memo: number, isOn: boolean): void {
        this.baseSymbolImage.setTexture(this.getSymbolImageRaw(memo).key, this.getSymbolImageRaw(memo).frame);
        this.baseSymbolImage.setTint(isOn ? 0xFFFFFF : 0x7F7F7F);
    }
    
    public turnOn() {
        this.on = true;
        this.applySymbolTint(this.getMemo(), true);
        this.reel!.expandingWild?.turnOnWildAnimation();
    }

    public turnOff() {
        this.on = false;
        this.applySymbolTint(this.getMemo(), false);
        this.stopAnimation();
        this.reel!.expandingWild?.turnOffWildAnimation();
    }

    public resetLayer() {
        if(!this.reel){
            return;
        }
        if (!this.reel.getContainer().exists(this.container)) {
            this.reel.getContainer().add(this.container);
        }
    }

    public showFrame() {}

    public hideFrame() {}

    public checkLayer() {}

    public setCellInfo(cellMemo: number, stopped: boolean = false, multiplier: number = 0) { 
        // this.baseGameContainer.setVisible(true);

        this.baseSymbolImage.setVisible(true);

        this.baseSymbolSpines.forEach(s => s.setVisible(false));

        this.setMemo(cellMemo);

        this.cancelDelayedAnimationForMemo();
        
        //Chiamata di idle
        if(ResourcesDispatcher.GAME_CONSTANTS.ANIMATED_SYMBOLS.includes(cellMemo)){
            this.scheduleDelayedAnimationForMemo(cellMemo);
        }

        this.on ? this.applySymbolTint(cellMemo, true) : this.applySymbolTint(cellMemo, false);

        this.linkSpinContainer.setVisible(false);

        // TODO: controllare questo codice e renderlo dinamico in base alla modalità
        // (in base potremmo non avere la modalità linkspin e quindi non ci serve mostrare i jackpot)
        // if (multiplier > 0 && 
        //     this.scene.gameArea.gameDataManager.getJackpots().map((jackpot: any) => { return jackpot * (window as any).getCurrentBet!().total}).indexOf(multiplier) === -1 && stopped) {
        //     this.linkSpineValueText.setText(Utils.formatCurrency(multiplier))
        //     this.linkSpinContainer.setVisible(true);
        // } else {
        //     this.linkSpineValueText.setText("");
        //     this.linkSpinContainer.setVisible(false);
        // }
    }

    public expandWild(isWinning: boolean): Promise<boolean> {
        return new Promise((resolve) => {
            this.baseSymbolImage.setVisible(false);

            const extraWildSpine = this.getExtraWildSpine();
            extraWildSpine.setVisible(false);

            this.reel!.getContainer().bringToTop(this.container);
            this.container.setVisible(true);

            const animationSuffix = String(3 - (this.index - 1));
            const animationState = extraWildSpine.animationState;

            const listener = {
                complete: async () => {
                    resolve(true);
                },
                start: () => {
                    this.scene.tweens.add({
                        targets: extraWildSpine,
                        alpha: 1,
                        duration: 50,
                        ease: 'Linear',
                        onComplete: () => {
                            extraWildSpine.setVisible(true);
                        }
                    });

                    if (isWinning) {
                        this.scene.soundManager.play(ResourcesDispatcher.SOUNDS.ESPANSIONE_JOLLY);
                        this.scene.animationManager.topSideGridAnimation?.jumpscare();
                    }
                }
            };

            animationState.setAnimation(0, "On_" + animationSuffix, false);

            if (isWinning) {
                const trackEntry = animationState.addAnimation(0, "opening_" + animationSuffix, false, 0);
                trackEntry.listener = listener;
            } else {
                const trackEntry = animationState.addAnimation(0, "nowin_" + animationSuffix, false, 0);
                trackEntry.listener = listener;
            }
        });
    }


    public contractWild(): Promise<boolean> {
        return new Promise((resolve) => {
            const extraWildSpine = this.getExtraWildSpine(); 

            if(extraWildSpine){
                const trackEntry = extraWildSpine.animationState.addAnimation(Cell.WinAnimationTrack, "closing_"+(3-(this.index-1)), false, 0);
                trackEntry.alpha = Cell.WinAnimationAlpha;

                const completeListener = {
                    complete: () => {
                        // Remove this specific listener after it is called
                        resolve(true);
                        extraWildSpine.animationState.removeListener(completeListener);
                    }
                    
                };
                trackEntry.listener = completeListener;
            } else {
                resolve(true);
            }
        });
    }

    public extraWildAnimation(isWinning: boolean): Promise<boolean> {
        return new Promise((resolve) => {
            this.baseSymbolImage.setVisible(false);

            const extraWildSpine = this.getExtraWildSpine();
            extraWildSpine.setVisible(true);

            this.reel!.getContainer().bringToTop(this.container);

            const animationState = extraWildSpine.animationState;

            if (isWinning) {
                animationState.addAnimation(0, "animation", false, 0);
            } 
            // else {
            //     this.turnOffWildAnimation();
            // }

            resolve(true);
        });
    }

    public turnOffWildAnimation() {
        this.getExtraWildSpine().skeleton.color.set(0.5, 0.5, 0.5, 1); 
    }

    public turnOnWildAnimation() {
        this.getExtraWildSpine().skeleton.color.set(1, 1, 1, 1); 
    }

    private isValidGameMode(): boolean {
        const gameMode = this.gameLogicVariableManager.getCurrentGameMode();
        return gameMode === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.BASEGAME || gameMode === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.LINKSPIN;
    }

    private setPlayAnimationListener(trackEntry: any, loop: boolean, resolve: Function) {
        if (!loop) {
            trackEntry.listener = {
                complete: () => {
                    if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
                        this.getSpine(this.getMemo()).setVisible(false);
                        this.getSpine(this.getMemo()).skeleton.setToSetupPose();
                        this.baseSymbolImage.setVisible(true);
                    } 
                    resolve(true);
                }
            };
        } else {
            resolve(true);
        }
    }

    public playAnimation(loop: boolean = false): Promise<boolean> {
        return new Promise((resolve) => {
            if(!this.isValidGameMode()){
                console.error("Mode not implemented");
                resolve(true);
                return;
            }

            const animations = this.getSymbolSpineRaw(this.getMemo()).animations;
            if(!animations){
                resolve(true);
                return;
            }

            const trackEntry = this.getSpine(this.getMemo()).animationState.addAnimation(Cell.WinAnimationTrack, animations[0], loop);
            trackEntry.alpha = Cell.WinAnimationAlpha;

            this.getSpine(this.getMemo()).setVisible(true);
            this.baseSymbolImage.setVisible(false);

            this.setPlayAnimationListener(trackEntry, loop, resolve);
        });
    }

    public playLandingAnimation(): Promise<boolean> {
        return new Promise((resolve) => {
            // a simple animation that zoom in and out the image
            this.baseSymbolImage.setVisible(true);
            // perform a zoom in and out animation
            this.scene.tweens.add({
                targets: this.baseSymbolImage,
                scaleX: 1.2,
                scaleY: 1.2,
                duration: 300,
                ease: 'Linear',
                yoyo: true,
                repeat: 0,
                onComplete: () => {
                    resolve(true);
                }
            });
        });
    }

    public stopAnimation() {
        if(this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD){
            this.cancelDelayedAnimationForMemo();
            this.getSpine(this.getMemo()).animationState.clearTrack(0);
            this.getSpine(this.getMemo()).setVisible(false);
            this.baseSymbolImage.setVisible(true);
        } else {
            this.cancelDelayedAnimationForMemo();
            this.getExtraWildSpine().animationState.clearTracks();
            this.getExtraWildSpine().setVisible(false);
            this.baseSymbolImage.setVisible(true);
        }
    }

    public hideWild() {
        this.getExtraWildSpine().setVisible(false);
        this.baseSymbolImage.setVisible(false);
    }
    
    private playIdleAnimation(memo: number, onComplete: Function): void {
        const animations = this.getSymbolSpineRaw(memo).animations;
        if (!animations) {
            onComplete();
            return;
        }

        const trackEntry = this.getSpine(memo).animationState.addAnimation(Cell.WinAnimationTrack, animations[2], false);
        trackEntry.alpha = Cell.WinAnimationAlpha;

        this.getSpine(memo).setVisible(true);
        this.baseSymbolImage.setVisible(false);

        trackEntry.listener = {
            complete: () => {
                if (this.getMemo() !== ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD) {
                    this.getSpine(memo).setVisible(false);
                    this.getSpine(memo).skeleton.setToSetupPose();
                    this.baseSymbolImage.setVisible(true);
                }

                onComplete();
            }
        };
    }

    private scheduleIdleAnimationLoop(memo: number): void {
        if (this.getMemo() !== memo) return;

        const delayMs = Math.floor(Math.random() * (20_000 - 5_000 + 1)) + 5_000;

        this.delayedAnimForMemo = this.scene.time.delayedCall(delayMs, () => {
            this.playIdleAnimation(memo, () => {
                if ((window as any).Game?.paused === false) {
                    this.scheduleIdleAnimationLoop(memo);
                }
            });
        });
    }

    public scheduleDelayedAnimationForMemo(memo: number) {
        this.cancelDelayedAnimationForMemo();
        this.scheduleIdleAnimationLoop(memo);
    }

    private cancelDelayedAnimationForMemo() {
        if (this.delayedAnimForMemo && !this.delayedAnimForMemo.hasDispatched) {
            this.delayedAnimForMemo.remove(false);
        }
        this.delayedAnimForMemo = undefined;
    }
}